import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DeviceMap from './DeviceMap';
import useInView from '../util/hooks/useInView';
import { getPublicDashboardToken } from '../../services/dashboardApi';

function DeviceMapWidgetView({ data }) {
  const [focusedDeviceId] = useState(null);
  const [containerRef, hasBeenInView] = useInView();
  const isPublicView = !!getPublicDashboardToken();

  const devices = (data && data.devices) || [];
  return (
    <div
      ref={containerRef}
      className="device-map-widget"
      style={{
        width: '100%',
        height: '100%',
        paddingTop: '40px',
        boxSizing: 'border-box',
      }}
    >
      {hasBeenInView ? (
        <DeviceMap
          devices={devices}
          height="100%"
          focusedDeviceId={focusedDeviceId}
          showEmptyStateCta={!isPublicView}
        />
      ) : (
        <div style={{ width: '100%', height: '100%' }} className="bg-light" />
      )}
    </div>
  );
}

DeviceMapWidgetView.propTypes = {
  data: PropTypes.shape({
    devices: PropTypes.array,
  }),
};

DeviceMapWidgetView.defaultProps = {
  data: null,
};

export { default as useDeviceMapWidgetData } from './useDeviceMapWidgetData';
export default DeviceMapWidgetView;
